export default __webpack_public_path__ + "static/media/logo.d0e27845.svg";